import Vue from 'vue'

Vue.component('text-input', {
  props: {
    name: String,
    label: String,
    type: {
      type: String,
      default: 'text'
    },
    modifier: {
      type: String,
      default: 'default'
    },
    textarea: {
      type: Boolean,
      default: false
    },
    autocorrect: Boolean,
    autocapitalize: Boolean,
    initialValueGetter: Function,
    placeholder: String,
    error: String,
    required: Boolean,
    validateMethod: Function,
    id: String,
    errorId: String,
    idDescribedby: Math.floor(100000000 + Math.random() * 900000000)
  },
  data () {
    const data = {
      isValid: true,
      isActive: false,
      showErrorMessage: false
    }

    if (this.initialValueGetter && this.initialValueGetter.bind !== 'undefined') {
      data['inputValue'] = this.initialValueGetter(this.name)
    } else {
      data['inputValue'] = ''
    }

    return data
  },
  watch: {
    inputValue () {
      this.$emit('change', {
        value: this.inputValue,
        name: this.name
      })
    },
    isValid () {
      if (!this.isValid) {
        this.$refs.input.setAttribute('aria-describedby', this.errorId)
      }
    }
  },
  mounted () {
    this.$emit('change', {
      value: this.inputValue,
      name: this.name
    })
    if (this.inputValue) this.setActive()
  },
  methods: {
    validate () {
      if (this.validateMethod) {
        this.isValid = this.validateMethod({
          value: this.inputValue,
          name: this.name
        })
      } else if (this.required && !this.inputValue) {
        this.isValid = false
      } else {
        this.isValid = true
      }
      return this.isValid
    },
    setActive () {
      this.isActive = true
    },
    unsetActive () {
      if (!this.inputValue) this.isActive = false
    },
    refresh () {
      setTimeout(() => {
        this.inputValue = this.$refs.input.value
        if (this.inputValue) this.setActive()
      }, 0)
    }
  },
  template: `
  <div class="text-input" :class="{ 'is-active': isActive, ['text-input--'+modifier]: true, 'is-invalid': !isValid }">
    <div class="text-input__wrapper" :class="{ 'with-textarea': textarea }">
      <input
        ref="input"
        v-if="!textarea"
        class="text-input__el p2"
        :id="id"
        :type="type"
        :name="name"
        :autocorrect="autocorrect"
        :autocapitalize="autocapitalize"
        :placeholder="placeholder"
        v-model="inputValue"
        v-on:focus="setActive"
        v-on:blur="unsetActive"
        :required="required" />
      <textarea
        ref="input"
        v-else
        class="text-input__el is-textarea p2"
        :class="{ 'has-error': !isValid }"
        :type="type"
        :id="id"
        :name="name"
        :autocorrect="autocorrect"
        :autocapitalize="autocapitalize"
        :placeholder="placeholder"
        v-model="inputValue"
        v-on:focus="setActive"
        v-on:blur="unsetActive"
        :required="required" />
      <label
        :for="id"
        v-if="label || modifier === 'default'"
        :class="['text-input__label', {'is-active': isActive, 'p3': modifier === ('default' || 'label'), 'p2': modifier === 'newsletter'}]">
        <span v-if="required" aria-label="* indicates a required field">*</span>{{(label ? label : placeholder)}}<span class="sr-only" v-if="required">Required Field</span>
      </label>
    </div>
    <transition name="fade">
      <p :id="errorId" v-if="!isValid" class="text-input__error red p3">{{error}}</p>
    </transition>
  </div>`
})
